export default __webpack_public_path__ + "static/media/java.7befc3a5.svg";